import {
  CREATE_COUPON_FAIL,
  CREATE_COUPON_REQUEST,
  CREATE_COUPON_SUCCESS,
  CREATE_PAYMENT_PLAN_FAIL,
  CREATE_PAYMENT_PLAN_REQUEST,
  CREATE_PAYMENT_PLAN_SUCCESS,
  CREATE_PLAN_DISCOUNT_FAIL,
  CREATE_PLAN_DISCOUNT_REQUEST,
  CREATE_PLAN_DISCOUNT_SUCCESS,
  CREATE_PROMO_CODE_FAIL,
  CREATE_PROMO_CODE_REQUEST,
  CREATE_PROMO_CODE_SUCCESS,
  CREATE_SERVICE_CHARGE_FAIL,
  CREATE_SERVICE_CHARGE_REQUEST,
  CREATE_SERVICE_CHARGE_SUCCESS,
  GET_COUPON_LIST_FAIL,
  GET_COUPON_LIST_REQUEST,
  GET_COUPON_LIST_SUCCESS,
  GET_COUPON_USAGE_LIST_FAIL,
  GET_COUPON_USAGE_LIST_REQUEST,
  GET_COUPON_USAGE_LIST_SUCCESS,
  GET_DLQ_MESSAGES_LIST_FAIL,
  GET_DLQ_MESSAGES_LIST_REQUEST,
  GET_DLQ_MESSAGES_LIST_SUCCESS,
  GET_PAYMENT_PLANS_LIST_FAIL,
  GET_PAYMENT_PLANS_LIST_REQUEST,
  GET_PAYMENT_PLANS_LIST_SUCCESS,
  GET_PAYMENT_PLAN_DETAIL_FAIL,
  GET_PAYMENT_PLAN_DETAIL_REQUEST,
  GET_PAYMENT_PLAN_DETAIL_SUCCESS,
  GET_PROMO_CODE_LIST_FAIL,
  GET_PROMO_CODE_LIST_REQUEST,
  GET_PROMO_CODE_LIST_SUCCESS,
  GET_PROMO_USAGE_LIST_FAIL,
  GET_PROMO_USAGE_LIST_REQUEST,
  GET_PROMO_USAGE_LIST_SUCCESS,
  GET_SERVICE_CHARGE_LIST_FAIL,
  GET_SERVICE_CHARGE_LIST_REQUEST,
  GET_SERVICE_CHARGE_LIST_SUCCESS,
  UPDATE_COUPON_FAIL,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_SUCCESS,
  UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL,
  UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST,
  UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS,
  UPDATE_PAYMENT_PLAN_FAIL,
  UPDATE_PAYMENT_PLAN_REQUEST,
  UPDATE_PAYMENT_PLAN_SUCCESS,
  UPDATE_PROMO_FAIL,
  UPDATE_PROMO_REQUEST,
  UPDATE_PROMO_SUCCESS,
  CREATE_MANUAL_CREDIT_GRANT_REQUEST,
  CREATE_MANUAL_CREDIT_GRANT_SUCCESS,
  CREATE_MANUAL_CREDIT_GRANT_FAIL,
  GET_ENTITY_TRANSACTIONS_REQUEST,
  GET_ENTITY_TRANSACTIONS_SUCCESS,
  GET_ENTITY_TRANSACTIONS_FAIL,
} from "../../Constants/PaymentConstants";

const initialStateDefault = {
  status: false,
  data: null,
  loading: true,
  error: null,
};

export const PaymentPlanListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_PAYMENT_PLANS_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_PAYMENT_PLANS_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_PAYMENT_PLANS_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PaymentPlanCreateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_PAYMENT_PLAN_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_PAYMENT_PLAN_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_PAYMENT_PLAN_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PromoCodeListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_PROMO_CODE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_PROMO_CODE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_PROMO_CODE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PromoCodeCreateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_PROMO_CODE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_PROMO_CODE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_PROMO_CODE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const ServiceChargeListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_SERVICE_CHARGE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_SERVICE_CHARGE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_SERVICE_CHARGE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const ServiceChargeCreateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_SERVICE_CHARGE_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_SERVICE_CHARGE_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_SERVICE_CHARGE_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const DLQMessagesListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_DLQ_MESSAGES_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_DLQ_MESSAGES_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_DLQ_MESSAGES_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PromoUsageListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_PROMO_USAGE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_PROMO_USAGE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_PROMO_USAGE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const UpdatePromoReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === UPDATE_PROMO_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_PROMO_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === UPDATE_PROMO_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CouponListReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_COUPON_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_COUPON_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_COUPON_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CouponUsageListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_COUPON_USAGE_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_COUPON_USAGE_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_COUPON_USAGE_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const CouponCreateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_COUPON_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_COUPON_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_COUPON_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const UpdateCouponReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === UPDATE_COUPON_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_COUPON_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === UPDATE_COUPON_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const FetchPlanDetailReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_PAYMENT_PLAN_DETAIL_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_PAYMENT_PLAN_DETAIL_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_PAYMENT_PLAN_DETAIL_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const UpdatePlanReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === UPDATE_PAYMENT_PLAN_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_PAYMENT_PLAN_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === UPDATE_PAYMENT_PLAN_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PlanDiscountCreateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_PLAN_DISCOUNT_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_PLAN_DISCOUNT_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_PLAN_DISCOUNT_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const PlanDiscountUpdateReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === UPDATE_PAYMENT_PLAN_DISCOUNT_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === UPDATE_PAYMENT_PLAN_DISCOUNT_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === UPDATE_PAYMENT_PLAN_DISCOUNT_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const ManualCreditGrantReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === CREATE_MANUAL_CREDIT_GRANT_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_MANUAL_CREDIT_GRANT_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === CREATE_MANUAL_CREDIT_GRANT_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const EntityTransactionsReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_ENTITY_TRANSACTIONS_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_ENTITY_TRANSACTIONS_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }

    if (action.type === GET_ENTITY_TRANSACTIONS_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};
